module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry-da2f433aacb4d6eacc7964c038b8b293.png";